import { MoldType } from './consts-and-types';

const roundToFixed = (value, digits) => {
  const rounded = Math.pow(10, digits);
  return (Math.round(value * rounded) / rounded).toFixed(digits);
};

const computeSplitPercentages = (value1, value2) => {
  const total = value1 + value2;
  return {
    percentage1: roundToFixed((100 * value1) / total, 0),
    percentage2: roundToFixed((100 * value2) / total, 0),
  };
};

const computeRoundArea = (radius) => Math.PI * radius * radius;

const computeRoundVolume = (radius, height) => computeRoundArea(radius) * height;

const computeRectangleArea = (width, length) => width * length;

const computeRectangleVolume = (width, length, height) => computeRectangleArea(width, length) * height;

const computePerimeter = (moldType, { length, radius, width }) => {
  if (moldType === MoldType.Round) {
    // Round
    return 2 * Math.PI * radius;
  } else {
    // Rectangle
    return 2 * (width + length);
  }
};

const computeCrustArea = (moldType, { height, length, radius, width }) => {
  if (moldType === MoldType.Round) {
    // Round
    const strip = computePerimeter(moldType, { radius }) * height;
    const bottom = computeRoundArea(radius);
    return { bottom, strip };
  } else {
    // Rectangle
    const strip = computePerimeter(moldType, { length, width }) * height;
    const bottom = computeRectangleArea(width, length);
    return { bottom, strip };
  }
};

const computeCrustVolume = (moldType, { crustWidth, height, length, radius, width }) => {
  const { bottom, strip } = computeCrustArea(moldType, { height, length, radius, width });
  return { bottom: bottom * crustWidth, strip: strip * crustWidth };
};

export { computeCrustArea, computeCrustVolume, computePerimeter, computeRectangleArea, computeRectangleVolume, computeRoundArea, computeRoundVolume, computeSplitPercentages, roundToFixed };
